
const OrderMngReportMenu = () =>
  import("~/components/Cafe/OrderMngReportMenu.vue");

export default {
  components: { OrderMngReportMenu },
  data() {
    return {};
  },

  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },
  },
};
